// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemRow_wrapper__If99z","details":"ItemRow_details__qPPbT"};